import { cn } from '@workspace/ui/lib/utils'

interface SearchingIndicatorProps {
  content: string
  resolved?: boolean
}

export function SearchingIndicator({ content, resolved }: SearchingIndicatorProps) {
  return (
    <div className="rounded-2xl rounded-tl-md border border-border bg-card px-4 py-3">
      <div className="flex items-center gap-3">
        <div
          className={cn(
            'flex size-6 items-center justify-center rounded-full',
            resolved ? 'bg-emerald-500/20' : 'bg-[#f97316]/20'
          )}
        >
          {resolved ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#10b981"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="size-3.5"
              role="img"
              aria-label="Complete"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#f97316"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="size-3.5 animate-spin"
              role="img"
              aria-label="Searching"
            >
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
          )}
        </div>
        <p className="text-sm text-muted-foreground">{content}</p>
      </div>
    </div>
  )
}
